import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { apiService } from '../services/api'
import {
  SUPPORTED_LANGUAGES,
  resolveLanguage,
  type SupportedLanguage,
} from '../i18n/config'

/**
 * 화면 언어 상태.
 *
 * - i18next 가 localStorage 에 선택을 저장한다
 * - `<html lang>` 을 함께 갱신해 접근성·SEO·브라우저 번역 판단에 반영한다
 * - 로그인 상태면 서버 프로필에도 저장해 기기 간에 유지된다
 */
export function useLanguage() {
  const { i18n } = useTranslation()
  const language = resolveLanguage(i18n.language)

  useEffect(() => {
    document.documentElement.lang = language
  }, [language])

  const changeLanguage = useCallback(
    async (next: SupportedLanguage) => {
      const target = resolveLanguage(next)
      await i18n.changeLanguage(target)
      document.documentElement.lang = target

      // 서버 저장은 부가 기능 — 실패해도 화면 언어는 유지한다
      if (localStorage.getItem('token')) {
        try {
          await apiService.updateUserProfile({
            preferences: { language: target },
          })
        } catch (error) {
          console.warn('언어 설정 서버 저장 실패:', error)
        }
      }
    },
    [i18n]
  )

  return {
    language,
    supported: SUPPORTED_LANGUAGES,
    changeLanguage,
  }
}

export default useLanguage
